import React from "react";
import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import { PolicyAuthorized } from "components/authorization/PolicyAuthorized";
import { RbacPolicies } from "components/authorization/RbacPolicies";

interface SubscriptionRateCardEmptyStateProps {
  onAssignDefault: () => void;
  onAssignNewRateCard: () => void;
}

export function SubscriptionRateCardEmptyState({
  onAssignDefault,
  onAssignNewRateCard,
}: SubscriptionRateCardEmptyStateProps) {
  return (
    <Stack spacing={2}>
      <Alert severity="info">
        No rate card is assigned to this subscription. Pricing falls back to plan defaults until a card is activated.
      </Alert>
      <Box
        sx={{
          border: 1,
          borderColor: "divider",
          borderRadius: 1,
          padding: 4,
          textAlign: "center",
        }}
      >
        <Typography variant="subtitle1">No active rate card</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 3 }}>
          A rate card will appear here when a quote for this subscription is accepted.
        </Typography>
        <PolicyAuthorized policies={RbacPolicies.RateCards.ReadWrite}>
          <Stack direction="row" spacing={2} sx={{ justifyContent: "center" }}>
            <Button variant="outlined" onClick={onAssignDefault}>
              Assign default
            </Button>
            <Button variant="contained" onClick={onAssignNewRateCard}>
              Assign new rate card
            </Button>
          </Stack>
        </PolicyAuthorized>
      </Box>
    </Stack>
  );
}
